export default __webpack_public_path__ + "static/media/ic_devices.2784f141.svg";